module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.action_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {}, [_c('div', [_vm._v("Order number: " + _vm._s(_vm.order_data.order_no))]), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(_vm.order_data.order_date))]), _vm._v(" "), _c('div', [_vm._v("Order Amount: ₦" + _vm._s(_vm.order_data.order_items_total))]), _vm._v(" "), _c('div', [_vm._v("Shipping:  ₦" + _vm._s(_vm.order_data.order_shipping_total))]), _vm._v(" "), _c('div', [_vm._v("Total: ₦" + _vm._s(_vm.order_data.order_total))]), _vm._v(" "), _c('div', [_vm._v("Status: "), _c('span', {
    style: ({
      color: _vm.order_data.order_status_color
    })
  }, [_vm._v(_vm._s(_vm.order_data.order_status))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "background-color": "bisque",
      "padding": "1em",
      "border-radius": "12px"
    }
  }, [_c('h3', {
    staticStyle: {
      "float": "right",
      "text-decoration": "underline"
    }
  }, [_vm._v("SELLER")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "clear": "right"
    }
  }, [_c('h4', [_vm._v("Shopping List")]), _vm._v(" "), _vm._l((_vm.order_data.order_items), function(item) {
    return _c('p', {
      key: item.order_item_no
    }, [_vm._v("\n              " + _vm._s(item.product_name) + " - ₦" + _vm._s(item.order_item_total.toFixed(2)) + "\n            ")])
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setPaymentDetails')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Yes, I have these Items")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "setPaymentDetails"
    }
  }, [_c('div', [_c('hr'), _vm._v(" "), _c('b', [_vm._v("Send Bank Details")]), _c('br'), _vm._v(" "), (_vm.sellpoint.business_bank_details && (Object.keys(_vm.sellpoint.business_bank_details).length > 0)) ? _c('div', [_c('span', [_vm._v("Send bank details details to receive order payment")]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#444444"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_number) + "\n                    ")])]), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomOrderDetailsUpdate(_vm.order_data)
      }
    }
  }, [_vm._v("Send")])]) : _c('div', [_vm._m(1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('ConfirmPaymentUpdate')
      }
    }
  }, [_vm._v("Confirm Payment")]), _vm._v(" "), (_vm.menu_tab_inner_view['ConfirmPaymentUpdate']) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Confirm Order Payment ?")]), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomConfirmPaymentUpdate(_vm.order_data)
      }
    }
  }, [_vm._v("Yes, Confirm Payment")])]) : _vm._e(), _vm._v(" "), _c('hr')])], 2)]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card-row"
  }, [_c('h5', [_vm._v("Order Additional Information")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#e94b4b"
    }
  }, [_vm._v("Add any order addtional information")]), _vm._v(" "), (_vm.setAddOrderAdditionalView) ? _c('div', [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_add_info.title),
      expression: "order_add_info.title"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.order_add_info.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_add_info.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_add_info.details),
      expression: "order_add_info.details"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.order_add_info.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_add_info.details = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_add_info.cost),
      expression: "order_add_info.cost"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.order_add_info.cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_add_info.cost = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": _vm.addOrderAdditionalView
    }
  }, [_vm._v("Add Information to Order")])])]) : _c('div', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.setAddOrderAdditionalView = true
      }
    }
  }, [_vm._v("Add Information")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('h5', [_vm._v("Process Order Request")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomUpdates(_vm.order_data, 'delivered', 3)
      }
    }
  }, [_vm._v("Mark as delivered")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomUpdates(_vm.order_data, 'closed', 3)
      }
    }
  }, [_vm._v("Close Order")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div')])]), _vm._v(" "), (_vm.order_data.order_payment_status_id != 18) ? _c('div', {
    staticClass: "mobile-fix-nav-2"
  }, [_c('p', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.order_data.order_status_id == 7) ? _c('div', {
    staticStyle: {
      "background": "#e94b4b",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.updateOrders(_vm.order, 'delivered')
      }
    }
  }, [_vm._v("Confirm Order Delivered ")])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Set Bank details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send Payment Link")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("A Payment link with payment details would be generated for payment")]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Send Payment Link")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eaa10aea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Manage/Orders/OrderDetailsRequest.vue
// module id = 636
// module chunks = 0